"use strict";

exports.__esModule = true;

exports.default = function (ref) {
  return {
    methods: {
      focus: function focus() {
        this.$refs[ref].focus();
      }
    }
  };
};

;


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/mixins/focus.js
// module id = 1oZe
// module chunks = 100